import * as user from './user';
import * as featuredEvent from './featuredEvent';
import * as featuredPerk from './featuredPerk';

export default {
  ...user,
  ...featuredEvent,
  ...featuredPerk,
};
